import {connect, setRecomputeState as setState} from '@gisatcz/ptr-state';
import Action from '../../../../../state/Action';
import Select from '../../../../../state/Select';

const mapStateToProps = (state, ownProps) => {
	setState(state);

	return {
		activeSelectionKey: Select.selections.getActiveKey(state),
		backgroundLayer: Select.maps.getMapBackgroundLayer(ownProps.stateMapKey),
		layers: Select.maps.getMapLayers(ownProps.stateMapKey),
		viewport: Select.maps.getViewportByMapKey(state, ownProps.stateMapKey),
		view: Select.maps.getViewByMapKey(state, ownProps.stateMapKey),
		viewLimits: Select.maps.getViewLimitsByMapKey(state, ownProps.stateMapKey),
		mapKey: ownProps.stateMapKey,
	};
};

const mapDispatchToPropsFactory = () => {
	return (dispatch, ownProps) => {
		return {
			onMount: (mapWidth, mapHeight) => {
				dispatch(
					Action.maps.setMapViewport(ownProps.stateMapKey, mapWidth, mapHeight)
				);
				dispatch(Action.maps.use(ownProps.stateMapKey, null, null));
			},

			onResize: (mapWidth, mapHeight) => {
				dispatch(
					Action.maps.setMapViewport(ownProps.stateMapKey, mapWidth, mapHeight)
				);
				dispatch(Action.maps.use(ownProps.stateMapKey, null, null));
			},

			onUnmount: () => {
				dispatch(Action.maps.mapUseClear(ownProps.stateMapKey));
			},

			onViewChange: update => {
				dispatch(Action.maps.updateMapAndSetView(ownProps.stateMapKey, update));
			},

			onPropViewChange: (update, mapWidth, mapHeight) => {
				dispatch(
					Action.maps.setMapViewport(ownProps.stateMapKey, mapWidth, mapHeight)
				);
				dispatch(Action.maps.use(ownProps.stateMapKey, undefined, undefined));
			},

			onClick: (mapKey, details) => {
				dispatch(Action.maps.setMapSetActiveMapKey(ownProps.stateMapKey));
				dispatch(
					Action.worldWater.handleOnClickCoordinates(details?.info?.coordinate)
				);
			},
			onLayerClick: (mapKey, layerKey, selectedFeatureKeys) => {
				dispatch(
					Action.worldWater.statistics.onLayerClick(
						selectedFeatureKeys,
						ownProps.stateMapKey,
						layerKey
					)
				);
			},
		};
	};
};

export default connect(mapStateToProps, mapDispatchToPropsFactory);
